import { render, staticRenderFns } from "./MiniEditor.vue?vue&type=template&id=daa850d8&"
import script from "./MiniEditor.vue?vue&type=script&lang=js&"
export * from "./MiniEditor.vue?vue&type=script&lang=js&"
import style0 from "./MiniEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports